import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import {
  clearDistrictPostalCodes,
  getDistrictPostalCodes,
} from '../../../../actions/location/DistrictPostalCode';

export const DistrictPostalCodeSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchGetDistrictPostalCodes,
  dispatchClearDistrictPostalCodes,
  closeMenuOnSelect,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearDistrictPostalCodes(), []);

  const onInputChange = (inputValue) => {
    if (inputValue.trim().length) {
      const isNumeric = /^\d+$/.test(inputValue);
      const query = isNumeric
        ? [`postalCode:${inputValue}`]
        : [`district:${inputValue}`];

      dispatchGetDistrictPostalCodes({ query });
    }
  };

  const filterOption = (users) => users;

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChange}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      filterOption={filterOption}
      closeMenuOnSelect={closeMenuOnSelect}
      {...rest}
    />
  );
};

DistrictPostalCodeSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetDistrictPostalCodes: PropTypes.func.isRequired,
  dispatchClearDistrictPostalCodes: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  closeMenuOnSelect: PropTypes.bool,
};

DistrictPostalCodeSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Seleccione...',
  closeMenuOnSelect: true,
};

const mapStateToProps = ({ LocationUnit }) => ({
  options: LocationUnit.DistrictPostalCode.getIn([
    'all',
    'content',
    'content',
  ]).map(({ id, postalCode, district, province, region }) => ({
    value: id,
    label: `${postalCode} - ${district} - ${province || ''} - ${region || ''}`,
  })),
  loading: LocationUnit.DistrictPostalCode.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetDistrictPostalCodes: getDistrictPostalCodes,
  dispatchClearDistrictPostalCodes: clearDistrictPostalCodes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DistrictPostalCodeSelect);
